module.exports = __webpack_public_path__ + "static/media/muteIcon.abca29c6.svg";